module.exports = __webpack_public_path__ + "static/media/CoinBase.eaa13ca3.png";